var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pricing-dialog',{staticClass:"mr-5",attrs:{"title":"Notificaties","header":["Soort", "Kosten per bericht"],"items":[{ name: "SMS", value: "€ 0,13 excl. BTW" }, { name: "Email", value: "Gratis" }]}})}
var staticRenderFns = []

export { render, staticRenderFns }